import React from 'react';
import { FEATURE_FLAGS } from '../../../engine/enhancers/questionEnhancer';
import { getQuestionPoolStats } from '../enhancedCategories';

const AIEnhancementBadge = ({ question, className = "" }) => {
  if (!FEATURE_FLAGS.AI_SELECTION) return null;
  
  const stats = getQuestionPoolStats();
  
  return (
    <div className={`inline-flex items-center space-x-2 ${className}`}>
      {/* AI Enhancement Indicator */}
      <div className="flex items-center space-x-1 px-2 py-1 bg-indigo-50 rounded-full">
        <span className="text-indigo-600 text-xs">🤖</span>
        <span className="text-xs font-medium text-indigo-700">AI Enhanced</span>
      </div>
      
      {/* Difficulty Badge */}
      {question?.difficulty && (
        <div className={`px-2 py-1 rounded-full text-xs font-medium ${
          question.difficulty === 'easy' ? 'bg-green-100 text-green-700' :
          question.difficulty === 'medium' ? 'bg-yellow-100 text-yellow-700' :
          'bg-red-100 text-red-700'
        }`}>
          {question.difficulty.toUpperCase()}
        </div>
      )}
      
      {/* Follow-up Indicator */}
      {question?.followUpTriggers && (
        <div className="px-2 py-1 bg-purple-50 text-purple-700 rounded-full text-xs font-medium">
          +{Object.keys(question.followUpTriggers).length} Follow-ups
        </div>
      )}
    </div>
  );
};

export default AIEnhancementBadge;